<template>
  <div
    :class="[
      $style.notificationItemTransaction,
      { [$style.notificationHeader]: !isNotificationPage },
    ]"
    :data-readed="notification.readed"
    @click="openModal"
  >
    <ItemWrapper
      :notification="notification"
      :is-notification-page="isNotificationPage"
      :class="$style.notificationItemTransactionWrapper"
    >
      <template #icon>
        <img v-if="notification.data.icon" :src="notification.data.icon.url" />
      </template>
      <template #rightSide>
        <span :class="[$style.notificationItemStatus, notification.data.statusId]">
          {{ notification.data.status }}
        </span>
        <BitButton
          v-if="isNotificationPage"
          :class="$style.notificationItemButtonHistory"
          type="secondary"
          no-margin
        >
          <template #prependIcon>
            <ArrowDown />
          </template>
          {{ transactionHistoryButton }}
        </BitButton>
      </template>
    </ItemWrapper>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import { computed } from 'vue';
import ArrowDown from '~/public/images/common/chevron-down.svg?component';
import { useStorePages } from '~/stores/abstract/pages';
import { useStoreMenuStatuses } from '~/stores/client/menuStatuses';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import { SettingsId } from '~/types/settings';
import ItemWrapper from '../itemWrapper/itemWrapper.vue';
import type { INotificationFeedElement } from '~/types/notifications';

defineProps({
  notification: {
    type: Object as PropType<INotificationFeedElement>,
    required: true,
  },
  isNotificationPage: {
    type: Boolean,
    default: false,
  },
});

const storeButtons = useStoreButtonTitles();
const storeMenuStatuses = useStoreMenuStatuses();

const transactionHistoryButton = computed(() => storeButtons.transactionHistory);

const openModal = () => {
  storeMenuStatuses.toggleNotificationsMenu(false);
  useStorePages().openAccountSettingsPage(SettingsId.History);
};
</script>

<style lang="scss" module src="./itemTransaction.scss"></style>
